import _ from "underscore";

const convertAtomsToApplicableClauses = atoms =>
  _.chain(atoms)
    .sortBy(atom => atom.reference)
    .value();

export default convertAtomsToApplicableClauses;
